"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnstructuredSubDataPointRecommendationStatus = exports.SubDataPointDataSubCategoryGuessStatus = exports.ConfidenceLabel = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.ConfidenceLabel = (0, type_utils_1.makeEnum)({
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
});
/** The approval status of the category guess for a subdatapoint */
exports.SubDataPointDataSubCategoryGuessStatus = (0, type_utils_1.makeEnum)({
    /** The guess has been approved as valid */
    Approved: 'APPROVED',
    /** The guess is pending review */
    Pending: 'PENDING',
    /** The guess has been marked as wrong */
    Rejected: 'REJECTED',
});
exports.UnstructuredSubDataPointRecommendationStatus = (0, type_utils_1.makeEnum)({
    /** The category was manually applied */
    ManuallyAdded: 'MANUALLY_ADDED',
    /** The recommendation has been corrected */
    Corrected: 'CORRECTED',
    /** The recommendation has been approved as valid */
    Validated: 'VALIDATED',
    /** The recommendation is has been made but not validated */
    Classified: 'CLASSIFIED',
    /** The recommendation has been marked as wrong */
    Rejected: 'REJECTED',
});
//# sourceMappingURL=datapoint.js.map